import { createAction, props } from '@ngrx/store';

export const addLoading = createAction('[Loading] Add', props<{ actionType: string }>());
export const stopLoading = createAction('[Loading] Stop');
export const forcesStopLoading = createAction('[Loading] Force Stop');
